






import { computed, defineComponent, nextTick, onMounted, ref } from '@nuxtjs/composition-api'
import { useEventListener } from '@vueuse/core'

export default defineComponent({
  setup () {
    const el = ref<Element | null>(null)
    const top = ref(99999)
    const setTop = async () => {
      await nextTick()
      top.value = el.value?.getBoundingClientRect().top ?? 99999
    }

    onMounted(() => {
      setTop()
      const events = ['scroll', 'resize']
      events.forEach(event => useEventListener(window, event, setTop))
    })

    const style = computed(() => ({
      top: `${top.value}px`,
    }))

    return {
      el,
      style,
    }
  },
})
